export default __webpack_public_path__ + "static/7901-173a211c2f47dd9730bc3bd778bf10c0.jpg";